<script setup lang="ts">
const { t } = useI18n();
const dataStore = useDataStore();
const DB = useDbStore();

const localDeliveryNotification = useLocalStorage('freeDeliveryNotification', false);

const showFreeDeliveryNotification = computed(() => {
  if (localDeliveryNotification.value) return false;
  if (!dataStore.user) return !localDeliveryNotification.value;

  return !dataStore.user?.freeDeliveryNotification;
});

const closeDeliveryNotification = () => {
  if (!dataStore.user) {
    localDeliveryNotification.value = true;
    return;
  }

  localDeliveryNotification.value = true;
  DB.updateUserData({
    freeDeliveryNotification: true,
  });
};
</script>

<template>
  <transition name="notification-slide">
    <div
      v-show="showFreeDeliveryNotification"
      class="xl:absolute left-0 top-0 h-9 bg-gray-900 text-gray-100 w-full text-center flex items-center justify-between px-[10%] max-md:px-1"
    >
      <div class="" />
      <div class="text-h5 max-md:text-big max-md:font-dedicated">
        {{ t('Free_delivery_banner') }}
      </div>
      <CloseButton
        size="small"
        class="!text-gray-800 hover:!text-gray-500"
        @click="closeDeliveryNotification"
      />
    </div>
  </transition>
</template>

<style scoped>
.notification-slide-enter-active,
.notification-slide-leave-active {
  transition: all 0.7s ease;
}

.notification-slide-enter-from {
  transform: translateY(-100%);
}

.notification-slide-leave-to {
  transform: translateY(-100%);
}
</style>
